import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { ensurePanelAdminSession, onPanelAuthChange } from "./utils/panelSession";

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState({
    checking: true,
    allowed: false,
  });

  useEffect(() => {
    let active = true;

    const verify = async () => {
      try {
        await ensurePanelAdminSession();
        if (active) {
          setState({ checking: false, allowed: true });
        }
      } catch {
        if (active) {
          setState({ checking: false, allowed: false });
        }
      }
    };

    verify();

    const unsubscribe = onPanelAuthChange(({ user, employee }) => {
      if (!active) return;
      if (!user || !employee) {
        setState({ checking: false, allowed: false });
        return;
      }
      setState((prev) => (prev.allowed ? prev : { checking: true, allowed: false }));
      verify();
    });

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  if (state.checking) {
    return <div style={loadingShell}>Checking admin session...</div>;
  }

  return state.allowed ? children : <Navigate to="/" replace />;
}

const loadingShell = {
  minHeight: "100vh",
  display: "grid",
  placeItems: "center",
  background: "#f8fafc",
  color: "#0f172a",
  fontFamily: "Inter, system-ui, sans-serif",
  fontWeight: 700,
};
